<template>
  <div class="page">
    <breadcrumb></breadcrumb>
    <div class="resume-form">
      <el-form
        ref="resumeForm"
        :model="formData"
        :rules="rules"
        label-width="180px"
        class="resume-form-content"
      >
        <div class="form-section">
          <h2 class="section-title">攀枝花市东区社会工作协会个人会员入会申请表</h2>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb.vue";
import { register } from "@/api/api.js";
export default {
  components: {
    breadcrumb,
  },
  data() {
    return {
      formData: {},
      rules: {},
    };
  },
};
</script>

<style scoped>
.page {
  padding: 0 5%;
  padding-bottom: 109px;
  padding-top: 26px;
}
.resume-form {
  width: 80%;
  margin: 0 auto;
  /* padding: 30px; */
  /* background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15); */
  margin-top: 24px;
}
/* 确保label文字不换行且全部显示 */
.resume-form-content >>> .el-form-item__label {
  white-space: nowrap;
}
.form-section {
  margin-bottom: 40px;
  padding: 25px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;
}
.section-title {
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid #409eff;
}
</style>